function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module undo/basecommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { transformSets } from '@ckeditor/ckeditor5-engine/src/model/operation/transform';
/**
 * Base class for undo feature commands: {@link module:undo/undocommand~UndoCommand} and {@link module:undo/redocommand~RedoCommand}.
 *
 * @protected
 * @extends module:core/command~Command
 */

var BaseCommand = /*#__PURE__*/function (_Command) {
  _inherits(BaseCommand, _Command);

  var _super = _createSuper(BaseCommand);

  function BaseCommand(editor) {
    var _this;

    _classCallCheck(this, BaseCommand);

    _this = _super.call(this, editor);
    /**
     * Stack of items stored by the command. These are pairs of:
     *
     * * {@link module:engine/model/batch~Batch batch} saved by the command,
     * * {@link module:engine/model/selection~Selection selection} state at the moment of saving the batch.
     *
     * @protected
     * @member {Array} #_stack
     */

    _this._stack = [];
    /**
     * Stores all batches that were created by this command.
     *
     * @protected
     * @member {WeakSet.<module:engine/model/batch~Batch>} #_createdBatches
     */

    _this._createdBatches = new WeakSet(); // Refresh state, so the command is inactive right after initialization.

    _this.refresh(); // Set the transparent batch for the `editor.data.set()` call if the
    // batch type is not set already.


    _this.listenTo(editor.data, 'set', function (evt, data) {
      // Create a shallow copy of the options to not change the original args.
      // And make sure that an object is assigned to data[ 1 ].
      data[1] = _objectSpread({}, data[1]);
      var options = data[1];

      if (options.batchType) {
        return;
      }

      options.batchType = 'transparent';
    }, {
      priority: 'high'
    }); // Clear the stack for the `transparent` batches.


    _this.listenTo(editor.data, 'set', function (evt, data) {
      // We can assume that the object exists - it was ensured
      // with the high priority listener before.
      var options = data[1];

      if (options.batchType === 'transparent') {
        _this.clearStack();
      }
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(BaseCommand, [{
    key: "refresh",
    value: function refresh() {
      this.isEnabled = this._stack.length > 0;
    }
    /**
     * Stores a batch in the command, together with the selection state of the {@link module:engine/model/document~Document document}
     * created by the editor which this command is registered to.
     *
     * @param {module:engine/model/batch~Batch} batch The batch to add.
     */

  }, {
    key: "addBatch",
    value: function addBatch(batch) {
      var docSelection = this.editor.model.document.selection;
      var selection = {
        ranges: docSelection.hasOwnRange ? Array.from(docSelection.getRanges()) : [],
        isBackward: docSelection.isBackward
      };

      this._stack.push({
        batch: batch,
        selection: selection
      });

      this.refresh();
    }
    /**
     * Removes all items from the stack.
     */

  }, {
    key: "clearStack",
    value: function clearStack() {
      this._stack = [];
      this.refresh();
    }
    /**
     * Restores the {@link module:engine/model/document~Document#selection document selection} state after a batch was undone.
     *
     * @protected
     * @param {Array.<module:engine/model/range~Range>} ranges Ranges to be restored.
     * @param {Boolean} isBackward A flag describing whether the restored range was selected forward or backward.
     * @param {Array.<module:engine/model/operation/operation~Operation>} operations Operations which has been applied
     * since selection has been stored.
     */

  }, {
    key: "_restoreSelection",
    value: function _restoreSelection(ranges, isBackward, operations) {
      var model = this.editor.model;
      var document = model.document; // This will keep the transformed selection ranges.

      var selectionRanges = []; // Transform all ranges from the restored selection.

      var transformedRangeGroups = ranges.map(function (range) {
        return range.getTransformedByOperations(operations);
      });
      var allRanges = transformedRangeGroups.flat();

      var _iterator = _createForOfIteratorHelper(transformedRangeGroups),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rangeGroup = _step.value;
          // While transforming there could appear ranges that are contained by other ranges, we shall ignore them.
          var transformed = rangeGroup.filter(function (range) {
            return range.root != document.graveyard;
          }).filter(function (range) {
            return !isRangeContainedByAnyOtherRange(range, allRanges);
          }); // All the transformed ranges ended up in graveyard.

          if (!transformed.length) {
            continue;
          } // After the range got transformed, we have an array of ranges. Some of those
          // ranges may be "touching" -- they can be next to each other and could be merged.


          normalizeRanges(transformed); // For each `range` from `ranges`, we take only one transformed range.
          // This is because we want to prevent situation where single-range selection
          // got transformed to multi-range selection.

          selectionRanges.push(transformed[0]);
        } // @if CK_DEBUG_ENGINE // console.log( `Restored selection by undo: ${ selectionRanges.join( ', ' ) }` );
        // `selectionRanges` may be empty if all ranges ended up in graveyard. If that is the case, do not restore selection.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (selectionRanges.length) {
        model.change(function (writer) {
          writer.setSelection(selectionRanges, {
            backward: isBackward
          });
        });
      }
    }
    /**
     * Undoes a batch by reversing that batch, transforming reversed batch and finally applying it.
     * This is a helper method for {@link #execute}.
     *
     * @protected
     * @param {module:engine/model/batch~Batch} batchToUndo The batch to be undone.
     * @param {module:engine/model/batch~Batch} undoingBatch The batch that will contain undoing changes.
     */

  }, {
    key: "_undo",
    value: function _undo(batchToUndo, undoingBatch) {
      var model = this.editor.model;
      var document = model.document; // All changes done by the command execution will be saved as one batch.

      this._createdBatches.add(undoingBatch);

      var operationsToUndo = batchToUndo.operations.slice().filter(function (operation) {
        return operation.isDocumentOperation;
      });
      operationsToUndo.reverse(); // We will process each operation from `batchToUndo`, in reverse order. If there were operations A, B and C in undone batch,
      // we need to revert them in reverse order, so first C' (reversed C), then B', then A'.

      var _iterator2 = _createForOfIteratorHelper(operationsToUndo),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var operationToUndo = _step2.value;
          var nextBaseVersion = operationToUndo.baseVersion + 1;
          var historyOperations = Array.from(document.history.getOperations(nextBaseVersion));
          var transformedSets = transformSets([operationToUndo.getReversed()], historyOperations, {
            useRelations: true,
            document: this.editor.model.document,
            padWithNoOps: false,
            forceWeakRemove: true
          });
          var reversedOperations = transformedSets.operationsA; // After reversed operation has been transformed by all history operations, apply it.

          var _iterator3 = _createForOfIteratorHelper(reversedOperations),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var operation = _step3.value;
              // Before applying, add the operation to the `undoingBatch`.
              undoingBatch.addOperation(operation);
              model.applyOperation(operation);
              document.history.setOperationAsUndone(operationToUndo, operation);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return BaseCommand;
}(Command); // Normalizes list of ranges by joining intersecting or "touching" ranges.
//
// @param {Array.<module:engine/model/range~Range>} ranges
//


export { BaseCommand as default };

function normalizeRanges(ranges) {
  ranges.sort(function (a, b) {
    return a.start.isBefore(b.start) ? -1 : 1;
  });

  for (var i = 1; i < ranges.length; i++) {
    var previousRange = ranges[i - 1];
    var joinedRange = previousRange.getJoined(ranges[i], true);

    if (joinedRange) {
      // Replace the ranges on the list with the new joined range.
      i--;
      ranges.splice(i, 2, joinedRange);
    }
  }
}

function isRangeContainedByAnyOtherRange(range, ranges) {
  return ranges.some(function (otherRange) {
    return otherRange !== range && otherRange.containsRange(range, true);
  });
}